import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import { Radio } from 'antd';

const { Group: AntGroup, Button: AntButton } = Radio;

export const Container = styled.div`
  width: 658px;
  margin: auto;
  padding-bottom: 40px;
`;

export const Box = styled(Flex).attrs({ direction: 'column' })`
  background: ${color.light};
  border: solid 1px ${color.gainsboro};
`;

export const BoxResult = styled.div`
  border-bottom: solid 1px ${color.gainsboro};
  color: ${color.dimgray};
  font-family: var(--bold-font);
  font-size: 16px;
  padding: 10px 20px;
  width: 100%;
`;

export const RadioGroup = styled(AntGroup)`
  margin: auto;
`;

export const RadioButton = styled(AntButton)`
  color: ${color.midgray};
  width: 80px;
  text-align: center;

  &:hover {
    color: ${color.midgray};
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {
    border-right-color: ${color.primary};
  }

  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: ${color.light};
    background: ${color.primary};
    border-color: ${color.primary};

    &::before {
      background-color: ${color.primary};
    }

    &:first-child {
      border-color: ${color.primary};
    }
  }
`;
